import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Dropzone from 'react-dropzone-uploader';
import { EndPoints, getAuthHeader, getBaseUrl, getImageUrl, UploadType } from '../../api';
import { getConfig, update } from '../../api/config';
import { Button } from '../../components/Button';
import { DateSquare } from '../../components/DateSquare';
import { SpinnerBlock } from '../../components/Spinner';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './vision.styl';
var VisionView = /** @class */ (function (_super) {
    __extends(VisionView, _super);
    function VisionView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            visionTitleError: false,
            visionOneContentError: false,
            visionTwoContentError: false,
            visionThreeContentError: false,
            visionContentOneState: '',
            visionContentTwoState: '',
            visionContentThreeState: '',
            visionImageError: false,
            visionImageTwoError: false,
        };
        _this.dropZoneOne = null;
        _this.dropZoneTwo = null;
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'visionTitle') {
                _this.setState({ visionTitleError: false });
            }
        };
        _this.getUploadParams = function (_) {
            return {
                url: getBaseUrl() + EndPoints.upload + '?type=' + UploadType.vision,
                headers: getAuthHeader(),
            };
        };
        _this.handleChangeStatusOne = function (params, status) {
            if (status === 'done') {
                var response = JSON.parse(params.xhr.response);
                _this.setState({
                    visionImage: response.data.fileName,
                });
                _this.dropZoneOne.files = [];
            }
        };
        _this.handleChangeStatusTwo = function (params, status) {
            if (status === 'done') {
                var response = JSON.parse(params.xhr.response);
                _this.setState({
                    visionImageTwo: response.data.fileName,
                });
                _this.dropZoneTwo.files = [];
            }
        };
        return _this;
    }
    VisionView.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var visionTitle = elements.visionTitle.value;
        if (visionTitle.length === 0) {
            this.setState({ visionTitleError: true });
            valid = false;
        }
        var htmlVisionOne = this.contentOneRef.getContent();
        if (isHtmlEmpty(htmlVisionOne)) {
            this.setState({ visionOneContentError: true });
            valid = false;
        }
        var htmlVisionTwo = this.contentTwoRef.getContent();
        if (isHtmlEmpty(htmlVisionTwo)) {
            this.setState({ visionTwoContentError: true });
            valid = false;
        }
        var htmlVisionThree = this.contentThreeRef.getContent();
        if (isHtmlEmpty(htmlVisionThree)) {
            this.setState({ visionThreeContentError: true });
            valid = false;
        }
        var visionImage = this.state.visionImage;
        if (!visionImage || visionImage.length === 0) {
            this.setState({ visionImageError: true });
            valid = false;
        }
        var visionImageTwo = this.state.visionImageTwo;
        if (!visionImageTwo || visionImageTwo.length === 0) {
            this.setState({ visionImageTwoError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            visionTitle: visionTitle,
            visionContentOne: htmlVisionOne,
            visionContentTwo: htmlVisionTwo,
            visionContentThree: htmlVisionThree,
            visionImage: visionImage || '',
            visionImageTwo: visionImageTwo || '',
        };
        this.setState({ loading: true });
        update(request).then(function (_) {
            _this.fetchData();
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    VisionView.prototype.componentDidMount = function () {
        var store = this.props.store;
        if (store) {
            this.fetchData();
        }
    };
    VisionView.prototype.fetchData = function () {
        var _this = this;
        this.setState({ loading: true });
        getConfig().then(function (result) {
            _this.setState({
                loading: false,
                config: result,
                visionImage: result === null || result === void 0 ? void 0 : result.visionImage,
                visionImageTwo: result === null || result === void 0 ? void 0 : result.visionImageTwo,
                visionContentOneState: (result === null || result === void 0 ? void 0 : result.visionContentOne) || '',
                visionContentTwoState: (result === null || result === void 0 ? void 0 : result.visionContentTwo) || '',
                visionContentThreeState: (result === null || result === void 0 ? void 0 : result.visionContentThree) || '',
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    VisionView.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var loading = state.loading, config = state.config, visionContentOneState = state.visionContentOneState, visionContentTwoState = state.visionContentTwoState, visionContentThreeState = state.visionContentThreeState;
        var i18n = props.store.i18n;
        var todayDate = new Date();
        return (React.createElement("div", { className: S.visionView },
            React.createElement("div", { className: S.visionHeaderContainer },
                React.createElement(DateSquare, { className: S.dateSquare, date: todayDate, size: 40 }),
                React.createElement("h1", { className: "moduleTitle" }, i18n.sideBarVision),
                React.createElement("div", { className: S.dayNotesContainer },
                    React.createElement("span", { className: S.dayNotesDate }, i18n.formatMediumDate(todayDate)))),
            React.createElement("hr", { className: "moduleSeparator" }),
            React.createElement("div", { className: S.visionMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("form", { className: "" + S.addDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                            React.createElement("div", null,
                                React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                                React.createElement("div", { className: S.addInputWrapper },
                                    React.createElement("label", { className: S.addInputTitle }, i18n.inputTitlePlaceholder),
                                    React.createElement("input", { className: S.addInput + " textInput", name: "visionTitle", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: config === null || config === void 0 ? void 0 : config.visionTitle })),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.visionTitleError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                                React.createElement("p", { className: "formSubtitle" },
                                    i18n.inputTitleContent,
                                    " #1"),
                                React.createElement(Editor, { onInit: function (_, editor) { return _this.contentOneRef = editor; }, apiKey: getEditorKey(), initialValue: visionContentOneState, init: getEditorOptions() }),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.visionOneContentError ? 'inputErrorActive' : '') }, i18n.validationIndicationError),
                                React.createElement("p", { className: "formSubtitle" },
                                    i18n.inputTitleIcon,
                                    " #1"),
                                React.createElement("div", { className: "formUploadWrapper" },
                                    state.visionImage ?
                                        React.createElement("img", { className: "preview", src: getImageUrl(state.visionImage) })
                                        :
                                            '',
                                    React.createElement(Dropzone, { ref: function (r) { return _this.dropZoneOne = r; }, getUploadParams: this.getUploadParams, onChangeStatus: this.handleChangeStatusOne, multiple: false, inputContent: i18n.inputUploaderPlaceholder, canRestart: true, canCancel: false, canRemove: false, accept: "image/*" })),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.visionImageError ? 'inputErrorActive' : '') }, i18n.validationImageError),
                                React.createElement("p", { className: "formSubtitle" },
                                    i18n.inputTitleContent,
                                    " #2"),
                                React.createElement(Editor, { onInit: function (_, editor) { return _this.contentTwoRef = editor; }, apiKey: getEditorKey(), initialValue: visionContentTwoState, init: getEditorOptions() }),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.visionTwoContentError ? 'inputErrorActive' : '') }, i18n.validationIndicationError),
                                React.createElement("p", { className: "formSubtitle" },
                                    i18n.inputTitleIcon,
                                    " #2"),
                                React.createElement("div", { className: "formUploadWrapper" },
                                    state.visionImageTwo ?
                                        React.createElement("img", { className: "preview", src: getImageUrl(state.visionImageTwo) })
                                        :
                                            '',
                                    React.createElement(Dropzone, { ref: function (r) { return _this.dropZoneTwo = r; }, getUploadParams: this.getUploadParams, onChangeStatus: this.handleChangeStatusTwo, multiple: false, inputContent: i18n.inputUploaderPlaceholder, canRestart: true, canCancel: false, canRemove: false, accept: "image/*" })),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.visionImageTwoError ? 'inputErrorActive' : '') }, i18n.validationImageError),
                                React.createElement("p", { className: "formSubtitle" },
                                    i18n.inputTitleContent,
                                    " #3"),
                                React.createElement(Editor, { onInit: function (_, editor) { return _this.contentThreeRef = editor; }, apiKey: getEditorKey(), initialValue: visionContentThreeState, init: getEditorOptions() }),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.visionThreeContentError ? 'inputErrorActive' : '') }, i18n.validationIndicationError)),
                            React.createElement(Button, { className: "primaryButton fullwidthButton " + S.visionButton, type: "submit", spinner: loading }, i18n.actionUpdate))))));
    };
    __decorate([
        action.bound
    ], VisionView.prototype, "onSubmit", null);
    VisionView = __decorate([
        inject('store'),
        observer
    ], VisionView);
    return VisionView;
}(React.Component));
export { VisionView };
